import {useSelector} from 'react-redux';
import {Button, Segment} from 'semantic-ui-react';
import {Link} from 'react-router-dom';

function EmptyConsultPackaeList() {
  const typeName = useSelector(state => state.student.data.type.name);

  return (
    <div className='text-center'>
      <p>
        <span>متاسفانه در حال حاضر بسته مشاوره‌ فعالی برای دوره </span>
        <span className='text-bold'>{typeName}</span>
        <span> موجود نمی‌باشد.</span>
      </p>

      <Segment compact className='my-4 mx-auto'>
        <p>برای تغییر دوره خود می‌توانید از دکمه زیر استفاده کنید.</p>
        <Button as={Link} to='/profile/update-student-type' color='blue' content='تغییر دوره'/>
      </Segment>

      <p>
        برای اطلاعات بیشتر با اکانت ادمین گروه مد مشاور در تلگرام با آدرس
        <a href='https://t.me/medmoshaver'> https://t.me/medmoshaver </a>
        در ارتباط باشید.
      </p>
      <a href='https://t.me/medmoshaver'>آدرس گروه مد مشاور در تلگرام</a>

    </div>
  );
}

export default EmptyConsultPackaeList;
